import {
  INITIATE_LOGIN, INITIATE_RESET_PASSWORD, INVALIDATE_LOGIN, RESET_EMAIL_SENT, RESET_EMAIL_ERROR,
} from '../actions/actionTypes';

export const loginState = (state, action) => {
  const initState = {
    isError: false,
    isSuccess: false,
    isPending: false,
    didInvalidate: false,
    message: '',
  };

  switch (action.type) {
    case INITIATE_LOGIN:
      return {
        ...initState, isPending: true,
      };
    case INVALIDATE_LOGIN:
      return {
        ...initState, isPending: false, isError: true, didInvalidate: true, message: action.payload.message,
      };
    case INITIATE_RESET_PASSWORD:
      return { ...initState, isPending: true };
    case RESET_EMAIL_SENT:
      return {
        ...initState, isPending: false, isError: false, didInvalidate: false, message: action.payload.message,
      };
    case RESET_EMAIL_ERROR:
      return {
        ...initState, isPending: false, isError: false, didInvalidate: true, message: action.payload.message,
      };
    default:
      return state || initState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js